import { Image, TouchableOpacity } from 'react-native'
import { ThemedView, ThemedText } from '@app/theme'

const DspAgreementErrorModal = ({ onContactUsPress }: { onContactUsPress: () => void }) => {




    return (
        <ThemedView justifyContent='center' alignItems='center' padding='lg' bg='bg-surface-primary'>
            <Image
                source={{ uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StatusFailed_1.svg' }}
                style={{ width: 48, height: 48 }}
            />
            <ThemedText mt='md' variant='b3s' color='text-primary'>Agreement signing failed!</ThemedText>
            <ThemedText mt='sm' mb='md' variant='b4r' color='text-secondary' textAlign='center'>{`We encountered an error while signing the loan agreement.\nPlease retry the process.`}</ThemedText>

            <ThemedView flexDirection='row' alignItems='center' justifyContent='space-between'>
                <ThemedText variant='b4r' color='text-secondary'>Need help?</ThemedText>
                <TouchableOpacity onPress={onContactUsPress}>
                    <ThemedText ml='xs' variant='b4b' color='text-action-primary'>Contact us</ThemedText>
                </TouchableOpacity>
            </ThemedView>

        </ThemedView>
    )
}

export default DspAgreementErrorModal